if (!customElements.get('size-table')) {
class SizeTable extends HTMLElement {
  constructor() {
    super();
    this.tableContainer = this.querySelector('.size-table__body');
    this.measurementsToggles = document.querySelectorAll('.size-table__measurements-input');
    this.regionSelector = this.querySelector('.region-selector');
    this.resizeRegionSelector = this.querySelector('.region-selector-resize');
    this.flags = {
      'GB': this.querySelector('.uk-flag'),
      'US': this.querySelector('.us-flag'),
      'EUR1': this.querySelector('.eu1-flag'),
      'EUR2': this.querySelector('.eu2-flag'),
      'IT': this.querySelector('.it-flag')
    };


    this.measurementsToggles.forEach((measurementsToggle) => {
      if (measurementsToggle) {
        measurementsToggle.addEventListener('change', this.onToggleChange.bind(this));
      }
    })

    if (this.regionSelector) {
      this.regionSelector.value = 'GB';
      this.updateFlag('GB');
      this.regionSelector.addEventListener('change', this.onRegionChange.bind(this));
    }

    if (this.tableContainer.dataset.table) {
      this.createTable(this.tableContainer.dataset.table);
    }
  }

  async createTable(url) {
    try {
      const sizeGuide = await this.downloadAndParseData(url)
      this.tableContainer.innerHTML = this.buildSizeGuide(sizeGuide)

    } catch (error) {
      throw new Error(error)
    }
  }

  downloadAndParseData(url) {
    return new Promise((resolve, reject) => {
      Papa.parse(url, {
        download: true,
        complete: (results) => {
          resolve(results)
        },
        error: (error) => {
          reject(error)
        },
      })
    })
  }

  buildSizeGuide(results) {
    let html = '';

    html = `
      <div class="size-table__table-wrapper">
        <table class="size-table__table">
          <tbody>
            <tr class="size-table__table-header">
              ${this.getTableHeaders(results.data[0])}
            </tr>
            ${this.getTableBody(results.data.slice(1))}
          </tbody>
        </table>
      </div>
    `;

    return html;
  }

  getTableHeaders(items) {
    let html = '';

    items.forEach((item, index) => {
      if (!this.classList.contains('size-table--conversions')) {
        html += `
          <th class="size-table__table-header-cell">
            ${this.getTableHeaderValue(item, index)}
          </th>
        `;
      }
    });

    return html;
  }

  getTableHeaderValue(item, index) {
    return this.tableContainer.hasAttribute('data-measurements') && index != 0
      ? `${item}<span class="cm"> (CM)</span><span class="inch"> (IN)</span>`
      : item
  }


  getTableBody(items) {
    let html = '';

    items.forEach((item) => {
      html += `
        <tr class="size-table__table-row">
          ${this.getTableCells(Object.values(item))}
        </tr>
      `;
    });

    return html;
  }

  getTableCells(items) {
    let html = '';

    items.forEach((item) => {
      html += `
        <td class="size-table__table-cell body-1">
          ${this.formatTableCell(item)}
        </td>
      `;
    });

    return html;
  }

  formatTableCell(item) {
    return item.includes('|') ? `<span class="cm">${item.split('|')[0]}</span><span class="inch">${item.split('|')[1]}</span>` : item
  }

  onToggleChange(event) {
    if (event.target.checked) {
      this.dataset.measurements = 'inch'
    } else {
      this.dataset.measurements = 'cm'
    }
  }

  onRegionChange(event) {
    const selectedOptionText = event.target.options[event.target.selectedIndex].text;
    this.resizeRegionSelector.options[0].innerHTML = selectedOptionText;
    event.target.style.width = `${this.resizeRegionSelector.clientWidth}px`;

    this.tableContainer.dataset.region = event.target.selectedIndex + 2;
    this.updateFlag(event.target.value);
  }

  updateFlag(region) {
    Object.keys(this.flags).forEach(key => {
      if (key === region) {
        this.flags[key].removeAttribute('hidden');
      } else {
        this.flags[key].setAttribute('hidden', true);
      }
    });
  }
 }

customElements.define('size-table', SizeTable);
}